import { ButtonGroup } from '@mui/material'
import React from 'react'
import { fontFamilies } from '@fedsim/constants'
import { GameButton } from './typography'

export function Actions({
  actions = [],
  payload = null,
  size = 'medium',
  orientation = 'vertical',
  variant = 'contained',
  fullWidth = true
}) {
  const fontFamily = fontFamilies.buttonFont
  return actions?.length > 0 ? (
    <ButtonGroup
      disableElevation
      fullWidth={fullWidth}
      orientation={orientation}
      size={size}
      sx={{ flexWrap: 'wrap' }}>
      {actions.map(({ title, onClick, Icon = false, color = 'success', dataQa = 'another-button' }) => {
        const clickHandler = e => {
          onClick(payload)
          e.stopPropagation()
        }
        return (
          <GameButton
            key={title}
            onClick={clickHandler}
            variant={variant}
            color={color}
            tabIndex={0}
            data-qa={dataQa}
            sx={{ fontFamily }}
            startIcon={Icon ? <Icon /> : false}
          >
            {title}
          </GameButton>
        )
      })}
    </ButtonGroup>
  ) : null
}

export default Actions
